import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    // Check initial scroll position
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMobileMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location]);
  const navLinks = [{
    to: '/',
    label: 'Home'
  }, {
    to: '/about',
    label: 'About'
  }, {
    to: '/services',
    label: 'Services'
  }, {
    to: '/edo-case-study',
    label: 'Edo Case Study'
  }, {
    to: '/portfolio',
    label: 'Portfolio'
  }, {
    to: '/clients',
    label: 'Clients'
  }, {
    to: '/contact',
    label: 'Contact'
  }];
  // Determine if we should use transparent background
  const shouldBeTransparent = isHomePage && !isScrolled;
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${shouldBeTransparent ? 'bg-transparent' : 'bg-white/95 backdrop-blur-md shadow-lg'}`} data-id="element-144">
      <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-145">
        <div className="flex items-center justify-between h-16 sm:h-20" data-id="element-146">
          {/* Logo */}
          <Link to="/" className="flex items-center group" data-id="element-147">
            <img src={shouldBeTransparent ? 'https://cdn.magicpatterns.com/uploads/m3EzG3aGX3C8qvhqEQC9KZ/2.png' : 'https://cdn.magicpatterns.com/uploads/vVe1BDC8ZbdaEjxBTrecAS/1.png'} alt="Manuel Technologies" className="h-8 sm:h-10 w-auto group-hover:scale-105 transition-transform duration-300" data-id="element-148" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-6 xl:gap-8" data-id="element-149">
            {navLinks.map(link => <Link key={link.to} to={link.to} className={`font-bold text-sm xl:text-base transition-colors relative group ${shouldBeTransparent ? 'text-white hover:text-blue-300' : 'text-slate-700 hover:text-blue-600'} ${location.pathname === link.to ? 'text-blue-600' : ''}`} data-id="element-150">
                {link.label}
                <span className={`absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-600 transition-all group-hover:w-full ${location.pathname === link.to ? 'w-full' : ''}`} data-id="element-151" />
              </Link>)}
            <Link to="/contact" className="px-4 xl:px-6 py-2 xl:py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-bold text-sm xl:text-base transition-all duration-300 hover:scale-105 hover:shadow-lg" data-id="element-152">
              Get Started
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className={`lg:hidden p-2 rounded-lg transition-colors ${shouldBeTransparent ? 'text-white hover:bg-white/10' : 'text-slate-900 hover:bg-slate-100'}`} data-id="element-153">
            {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-154" /> : <Menu className="w-6 h-6" data-id="element-155" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="lg:hidden bg-white border-t border-slate-200 shadow-xl" data-id="element-156">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 space-y-4" data-id="element-157">
            {navLinks.map(link => <Link key={link.to} to={link.to} className={`block py-2 font-bold transition-colors ${location.pathname === link.to ? 'text-blue-600' : 'text-slate-700 hover:text-blue-600'}`} data-id="element-158">
                {link.label}
              </Link>)}
            <Link to="/contact" className="block w-full px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white text-center rounded-lg font-bold transition-colors" data-id="element-159">
              Get Started
            </Link>
          </div>
        </div>}
    </nav>;
}